import React from 'react'
import { PageWrapper } from './../common/wrappers';
import { Header, PageTabs, NavigationBar, FormSection, Footer } from './../containers';
import { TermsModal, PaymentModal, PaymentAuthModal, WebCamModal, ApplicationOverrideModal } from './../models'


const ApplicatonFormWeb = () => {
  let vh = window.innerHeight * 0.01;
  return (
    <PageWrapper vh={vh} >
      <Header />
      <PageTabs />
      <FormSection />
      <NavigationBar />
      <TermsModal />
      <PaymentModal />
      <PaymentAuthModal />
      <WebCamModal />
      <ApplicationOverrideModal />
      <Footer />
    </PageWrapper>
  )
}

export default ApplicatonFormWeb
